import { render, staticRenderFns } from "./channel__list.vue?vue&type=template&id=9b968c66"
import script from "./channel__list.vue?vue&type=script&lang=js"
export * from "./channel__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports